import { QueryFunctionContext, useInfiniteQuery, useQuery } from 'react-query';

import { getTracks, list as listFn } from './service';

interface SessionsArguments {
  eventId: string;
  selectedTracks: string[];
}
interface SessionsArgumentsOptional {
  searchValue?: string;
}
type SessionsKey = [
  'sessions',
  string /* eventId */,
  string[] /* selectedTracks */,
  SessionsArgumentsOptional
];

const sessionsQuery = {
  getQueryKey: (
    eventId: string,
    selectedTracks: string[],
    param: SessionsArgumentsOptional
  ): SessionsKey => ['sessions', eventId, selectedTracks, param],
  queryFn: ({
    pageParam,
    queryKey: [, eventId, selectedTracks, param],
  }: QueryFunctionContext<SessionsKey>) =>
    listFn(eventId, pageParam || 0, selectedTracks, param.searchValue),
};

export const useSessions = ({
  eventId,
  selectedTracks,
  searchValue,
}: SessionsArguments & SessionsArgumentsOptional) =>
  useInfiniteQuery({
    queryKey: sessionsQuery.getQueryKey(eventId, selectedTracks, { searchValue }),
    queryFn: sessionsQuery.queryFn,
  });

type TracksKey = ['tracks', string /* eventId */];

const tracksQuery = {
  getQueryKey: (eventId: string): TracksKey => ['tracks', eventId],
  queryFn: ({ queryKey: [, eventId] }: QueryFunctionContext<TracksKey>) => getTracks(eventId),
};

export const useTracks = (eventId: string) =>
  useQuery({
    queryKey: tracksQuery.getQueryKey(eventId),
    queryFn: tracksQuery.queryFn,
  });
